const callCommand = JSON.stringify({ name: 'action/call', message: {} });

const backCommand = JSON.stringify({ name: 'action/back', message: {} });

const closeCommand = JSON.stringify({ name: 'action/close', message: {} });

const filterCommand = JSON.stringify({ name: 'poiList/applyFilter', message: {} });

const goNowCommand = JSON.stringify({ name: 'action/goNow', message: {} });

const removeFavoriteCommand = JSON.stringify({ name: 'action/removeAsFavorite', message: {} });

const saveFavoriteCommand = JSON.stringify({ name: 'action/saveAsFavorite', message: {} });

const shareCommand = JSON.stringify({ name: 'action/share', message: {} });

const addStopCommand = JSON.stringify({ name: 'action/addStop', message: {} });

const replaceStopCommand = JSON.stringify({ name: 'action/replaceStop', message: {} });

const addNewRouteCommand = JSON.stringify({ name: 'destinationInformation/newRoute', message: {} });

const routePreviewCommand = JSON.stringify({
  name: 'destinationInformation/routePreview',
  message: {},
});

const routesCommand = JSON.stringify({ name: 'action/routes', message: {} });

const editFavCancelCommand = JSON.stringify({ name: 'editFavorites/cancel', message: {} });

const editFavloadCommand = JSON.stringify({ name: 'editFavorites/load', message: {} });

const editFavSaveCommand = JSON.stringify({ name: 'editFavorites/save', message: {} });

const editRecCancelCommand = JSON.stringify({ name: 'editRecents/cancel', message: {} });

const editRecentLoadCommand = JSON.stringify({ name: 'editRecents/load', message: {} });

const editRecHideCommand = JSON.stringify({ name: 'editRecents/hidePOI', message: {} });

const editRecSaveCommand = JSON.stringify({ name: 'editRecents/save', message: {} });

const editStopsBackCommand = JSON.stringify({ name: 'editStops/back', message: {} });

const editStopsRemoveCommand = JSON.stringify({ name: 'editStops/removeStop', message: {} });

const saveCommand = JSON.stringify({ name: 'action/save', message: {} });

const editStopsReorderCommand = JSON.stringify({ name: 'editStops/reorder', message: {} });

const continueTripCommand = JSON.stringify({ name: 'selectRoutes/continueTrip', message: {} });

const waypointCollapseCommand = JSON.stringify({
  name: 'routeWaypointDetails/collapse',
  message: {},
});

const waypointEditstopsCommand = JSON.stringify({
  name: 'routeWaypointDetails/editStops',
  message: {},
});

const waypointEditTripCommand = JSON.stringify({
  name: 'routeWaypointDetails/endTrip',
  message: {},
});

const waypointRoutesCommand = JSON.stringify({ name: 'routeWaypointDetails/routes', message: {} });

const waypointShareEtaCommand = JSON.stringify({
  name: 'routeWaypointDetails/shareETA',
  message: {},
});

const homeCommand = JSON.stringify({ name: 'destinations/home', message: {} });

const workCommand = JSON.stringify({ name: 'destinations/work', message: {} });

const favoritesCommand = JSON.stringify({ name: 'destinations/favorites', message: {} });

const recentsCommand = JSON.stringify({ name: 'destinations/recents', message: {} });

const parkingCommand = JSON.stringify({ name: 'destinations/parking', message: {} });

const fuelCommand = JSON.stringify({ name: 'destinations/fuel', message: {} });

const foodCommand = JSON.stringify({ name: 'destinations/food', message: {} });

const hospitalsCommand = JSON.stringify({ name: 'destinations/hospitals', message: {} });

const deleteCommand = index => JSON.stringify({ name: 'action/delete', message: { index } });

const selectPoiCommand = index =>
  JSON.stringify({ name: 'action/selectedIndex', message: { index } });

const updateListCommand = poiList =>
  JSON.stringify({ name: 'poiList/updateList', message: { poiList } });

const poiLatLongCommand = poiData =>
  JSON.stringify({ name: 'action/getPoiFromLatLong/return', message: { poiData } });

const editFavHidePoi = index =>
  JSON.stringify({ name: 'editFavorites/hidePOI', message: { index } });

const showNearbyParkingCommand = poiData =>
  JSON.stringify({ name: 'moreInfo/showNearbyParking', message: { poiData } });

const viewParkingCommand = parkingList =>
  JSON.stringify({ name: 'moreInfo/viewParking', message: { parkingList } });

const plotIconsCommand = visiblePOIs =>
  JSON.stringify({ name: 'poiList/plotIconsOnMap', message: { ...visiblePOIs } });

export default {
  callCommand,
  backCommand,
  closeCommand,
  goNowCommand,
  removeFavoriteCommand,
  saveFavoriteCommand,
  shareCommand,
  addStopCommand,
  addNewRouteCommand,
  routePreviewCommand,
  routesCommand,
  editFavCancelCommand,
  editFavSaveCommand,
  editRecCancelCommand,
  editRecHideCommand,
  editRecSaveCommand,
  editStopsBackCommand,
  editStopsRemoveCommand,
  saveCommand,
  waypointCollapseCommand,
  waypointEditstopsCommand,
  waypointEditTripCommand,
  waypointRoutesCommand,
  waypointShareEtaCommand,
  selectPoiCommand,
  updateListCommand,
  poiLatLongCommand,
  editFavHidePoi,
  showNearbyParkingCommand,
  viewParkingCommand,
  filterCommand,
  plotIconsCommand,
  editStopsReorderCommand,
  deleteCommand,
  editFavloadCommand,
  homeCommand,
  workCommand,
  favoritesCommand,
  recentsCommand,
  parkingCommand,
  fuelCommand,
  foodCommand,
  hospitalsCommand,
  continueTripCommand,
  editRecentLoadCommand,
  replaceStopCommand,
};
